import { render, staticRenderFns } from "./WebsiteHome.vue?vue&type=template&id=6fca70aa&scoped=true&"
import script from "./WebsiteHome.vue?vue&type=script&lang=js&"
export * from "./WebsiteHome.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteHome.vue?vue&type=style&index=0&id=6fca70aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fca70aa",
  null
  
)

export default component.exports